/**
 * 关于dom操作的工具方法
 */

/**
 * 添加calss
 * @param { element } 元素
 * @param { string } 类名
 */
export function addClass(el, className) {
	if (hasClass(el, className)) {
		return;
	}
	let newClass = el.className.split(' ');
	newClass.push(className);
	el.className = newClass.join(' ');
}
/**
 * 判断元素是否存在类名
 * @param { element } 元素
 * @param { string } 类名
 * @returns { boolean }
 */
export function hasClass(el, className) {
	let reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
	return reg.test(el.className);
}
/**
 * 动态添加icon
 * @param { icon } icon地址
 */
export function setIcon(icon) {
	let link = document.querySelector('link[rel*="icon"]');
	link.href = icon;
}
